import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "place/type-spot-detail"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }


}

export default new service();

